import React from "react"
import { StaticQuery, graphql } from 'gatsby'
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import Newsletter from "../../components/newsletter"
import Scrollspy from 'react-scrollspy'
import Img from 'gatsby-image'
import { AutoAffix } from 'react-overlays'
import { Link } from '../../components/localizedlink'
import { navigate } from 'gatsby'
import { translatePage } from '../../utils'
import hero from '../../images/contents/hero-iic-white.png';
import heroSm from '../../images/contents/hero-iic-sm-white.png';

const Report2019 = ({ pageContext: { locale } }) => (
  <StaticQuery
  query={graphql`
    query {
      angelini: file(relativePath: {eq: "contents/01angelini.jpg"}){
        ...sharpReport
      }
      fastweb: file(relativePath: {eq: "contents/02_fastweb.jpg"}){
        ...sharpReport
      }
      ferrero: file(relativePath: {eq: "contents/03_ferrero.jpg"}){
        ...sharpReport
      }
      rai: file(relativePath: {eq: "contents/04_rai.jpg"}){
        ...sharpReport
      }
      case_aboca: file(relativePath: {eq: "contents/report/case/aboca.jpg"}){
        ...sharpReport
      }
      case_adb: file(relativePath: {eq: "contents/report/case/adb.jpg"}){
        ...sharpReport
      }
      case_fater: file(relativePath: {eq: "contents/report/case/fater.jpg"}){
        ...sharpReport
      }
      case_generali: file(relativePath: {eq: "contents/report/case/generali.jpg"}){
        ...sharpReport
      }
      case_ima: file(relativePath: {eq: "contents/report/case/ima.jpg"}){
        ...sharpReport
      }
      case_iren: file(relativePath: {eq: "contents/report/case/iren.jpg"}){
        ...sharpReport
      }
      case_istat: file(relativePath: {eq: "contents/report/case/istat.jpg"}){
        ...sharpReport
      }
      case_poste: file(relativePath: {eq: "contents/report/case/poste.jpg"}){
        ...sharpReport
      }
      case_sella_homei: file(relativePath: {eq: "contents/report/case/sella-homei.jpg"}){
        ...sharpReport
      }
      case_sky: file(relativePath: {eq: "contents/report/case/sky.jpg"}){
        ...sharpReport
      }
      case_supsi: file(relativePath: {eq: "contents/report/case/supsi.jpg"}){
        ...sharpReport
      }
      case_tim: file(relativePath: {eq: "contents/report/case/tim.jpg"}){
        ...sharpReport
      }
      tendenze_adb: file(relativePath: {eq: "contents/report/tendenze/adb.jpg"}){
        ...sharpReport
      }
      tendenze_angelini: file(relativePath: {eq: "contents/report/tendenze/angelini.jpg"}){
        ...sharpReport
      }
      tendenze_generali: file(relativePath: {eq: "contents/report/tendenze/generali.jpg"}){
        ...sharpReport
      }
      tendenze_iren: file(relativePath: {eq: "contents/report/tendenze/iren.jpg"}){
        ...sharpReport
      }
      tendenze_rai: file(relativePath: {eq: "contents/report/tendenze/rai.jpg"}){
        ...sharpReport
      }
      tendenze_rai_academy: file(relativePath: {eq: "contents/report/tendenze/rai-academy.jpg"}){
        ...sharpReport
      }
      tendenze_sky: file(relativePath: {eq: "contents/report/tendenze/sky.jpg"}){
        ...sharpReport
      }
    }
  `}
  render={data => {
    return (
    <Layout locale={locale}>
      <SEO title="Executive summary IIC 2019" bodyClass="header-testata site-white" />
      <div className="gradiente">
        <section className="section evento evento--edizione">
          <div className="champions-hero-text">
            <div className="container">
              <div className="row">
                <div className="col-md-10 col-md-offset-1">
                  <div className="champions-hero-text__logo">IIC</div>
                  <div className="champions-hero-text__edition">First Edition</div>
                  <div className="champions-hero-text__title">Intranet Italia <br className="visible-md-block visible-lg-block" />Champions</div>
                  <div className="champions-hero-text__subject">The award for the best <br className="visible-md-block visible-lg-block" />Italian intranet projects</div>
                  <div className="champions-hero-text__claim">Event created by Giacomo Mason from <a href="https://www.intranetmanagement.it/" title="Intranet Management" target="_blank" rel="noopener noreferrer">Intranet Management</a>,  <br className="d-none d-lg-block" />part of Gruppo <a href="https://www.ariadnedigital.it/" title="Ariadne Digital" target="_blank" rel="noopener noreferrer">Ariadne Digital</a></div>
                </div>
              </div>
            </div>
          </div>
          <picture>
            <source media="(min-width: 768px)" srcSet={hero} />
            <img src={heroSm} alt="INTRANET ITALIA CHAMPIONS" />
          </picture>
        </section>

        <div className="champions">
          <div className="container">
            <div className="row">
              <div id="leftcol" className="hidden-xs col-sm-4 col-md-2 col-md-offset-1">
                <div id="sidebar">
                  <AutoAffix affixClassName="affix" topClassName="affix-top" bottomClassName="affix-bottom"
                    container={() => document.getElementById('scrollContainer')}>
                    
                    <div id="leftnav" className="champions__nav nav">
                      <div className="left-nav__primary left-nav__primary--active">Report 2019</div>
                      <nav className="left-nav">
                        <Scrollspy items={['vincitori', 'casestudy', 'tendenze', 'report']} offset={-20}
                          className="left-nav__list" currentClassName="active">
                          <li className="left-nav__item left-nav__item--1">
                            <a href="#vincitori" title="i vincitori" className="left-nav__link">The winners</a>
                          </li>
                          <li className="left-nav__item left-nav__item--2">
                            <a href="#casestudy" title="Casi di studio" className="left-nav__link">Case studies</a>
                          </li>
                          <li className="left-nav__item left-nav__item--3">
                            <a href="#tendenze" title="Le 8 tendenze del 2019" className="left-nav__link">Some trends</a>
                          </li>
                          <li className="left-nav__item left-nav__item--4">
                            <a href="#report" title="Report 2019" className="left-nav__link">Buy the Report</a>
                          </li>
                        </Scrollspy>
                      </nav>
                      <div className="left-nav__primary"><Link to="/intranet-italia-champions/">What is IIC</Link></div>
                     
                      <div className="champions__logo">IIC</div>
                    </div>
                  </AutoAffix>
                </div>
              </div>
              <div className="col-sm-8 col-md-6">
                <div className="champions__text" id="scrollContainer">
                  <div className="page-section">
                    <div id="vincitori">
                      <div className="number">IIC</div>
                      <h1>Executive Summary</h1>
                     
                      <p>
                        The 4 overall winners of the first edition (2019) of the IIC are
                      </p>
                      <ul>
                        <li><strong>Angelini Group</strong></li>
                        <li><strong>Fastweb</strong></li>
                        <li><strong>Rai</strong></li>
                        <li><strong>Ferrero</strong></li>
                      </ul>
                      <p>
                        These companies have each created projects of great interest in terms of design, content or intranet functionality. In a short phrase, innovation in internal communication.
                        <br/>
                        Here is a brief description of the winning projects of the 2019 edition of the award:
                      </p>
                      <p>
                        <strong>Angelini Group</strong> - A new digital workplace.<br/>
                        Angelini has created a highly complex digital workplace, with a lot of care and attention taken
                        in terms of design, a truly inclusive ideation process, which involved employees and took
                        their needs into account. The strong profiling, the e-commerce dedicated to the staff and the
                        excellent mobile version make this intranet a really successful project.
                      </p>
                      <Img fluid={data.angelini.childImageSharp.fluid} alt="Angelini Group" className="champions__img"/>


                      <p>
                        <strong>Fastweb</strong> - A dedicated app for desk booking.<br/>
                        Fastweb has created an application to support an innovative process of the company (the change
                        of working methods in its new location), capable of improving people’s lives and involving them in
                        the design process. Today employees have an evolved and inclusive tool which encourages and
                        supports collaboration.
                      </p>
                      <Img fluid={data.fastweb.childImageSharp.fluid} alt="Fastweb" className="champions__img"/>


                      <p>
                        <strong>Ferrero</strong> - An advanced, profiled and multilingual digital workplace.<br/>
                        Ferrero took on the challenge of creating a single portal profiled in 10 different languages, suitable
                        from employees and workers, to the independent user, and has succeeded very well in doing so.
                        The design, customization, applications and initiatives made make this project an advanced
                        and quality digital workplace.
                      </p>
                      <Img fluid={data.ferrero.childImageSharp.fluid} alt="Ferrero" className="champions__img"/> 


                      <p>
                        <strong>Rai - RaiPlace</strong> - Attendance, training and information management.<br/>
                        Rai has created a sophisticated and multifunctional portal, capable of communicating with the various systems of the company and creating a unique and pleasant user experience for the employee. Online attendance management, my page, integrated notifications, and training are important pieces of a pathway towards efficiency and the centrality of people within the company.
                      </p>
                      <Img fluid={data.rai.childImageSharp.fluid} alt="Rai - RaiPlace" className="champions__img"/> 

                    </div>
                  </div>

                  <div id="casestudy" className="page-section">
                    <h1>Case studies</h1>
                    <p>
                      Below are the 12 projects that, out of the different categories of the award, have expressed elements of great interest and inspiration for anyone dealing with intranet projects. These are examples of interesting and innovative achievements and, in some cases, each with their own original and effective solutions.    
                    </p>

                    <strong>Contents and initiatives</strong>
                    <ul>
                      <li>Gruppo Sella - Corporate values and multichannel logic</li>
                      <li>Generali Italia - Organization chart, social wall and web radio</li>
                      <li>IMA - Sector areas and targeted contents.</li>
                      <li>IREN - of values and self-produced videos.</li>
                      <li>Poste Italiane - Poste Italiane’s national football team.</li>
                      <li>TIM - The campaign for inclusion.</li>
                    </ul>
                    <strong>Applications and services</strong>
                    <ul>
                      <li>Gruppo Aboca - An inclusive APP for the employees.</li>
                      <li>Bologna Airport - A location-based TV intranet.</li>
                      <li>ISTAT - Online management of HR reservations.</li>
                    </ul>

                    <strong>Social</strong>
                    <ul>
                      <li>Fater - A personalized portal for employees.</li>
                    </ul>
                  
                    <strong>Design solutions</strong>
                    <ul>
                      <li>Sky Italia - Restyling, new editorial formats and an A-Z index for the intranet.</li>
                      <li>SUPSI - A Customized Employee Portal</li>
                    </ul>

                  </div>

                  <div id="tendenze" className="page-section">
                    <h1>Some trends</h1>
                    <p>
                      Can we identify any trends among the cases that we have been presented with this year?<br/>
                      In fact, we can encounter some of them, some of which are also present in the international arena, some of which can also be observed in the projects we have had the chance to examine.
                      <br/>
                      Below we have outlined some of the main examples.
                    </p>


                    <p>
                      <strong>Frontline training. </strong> 
                      More and more often, intranet projects contain areas dedicated to training that are
                      particularly well structured, such as those created by <strong>Rai</strong> , <strong>Angelini</strong>  and <strong>Ferrero</strong> . Sometimes these may
                      be in the form of material libraries, video files, course catalogues or even real e-learning platforms
                      integrated into the intranet. Other examples, as in the case of <strong>Fater</strong>, the training material is designed
                      to be a sort of “path” within the intranet environment which enable the employee to acquire new skills
                      necessary for the adoption of a new way of working.
    
                    </p>
                    <figure className="champions__img">
                      <Img fluid={data.tendenze_rai_academy.childImageSharp.fluid} alt="Rai academy"/> 
                      <figcaption>Il catalogo corsi di Rai Academy</figcaption>
                    </figure>
                    <p>
                      <strong>The arrival of APPs. </strong> 
                      Although most companies approach the issue of mobility by adopting responsive
                      versions of intranets rather than purpose-built apps (for various reasons of optimization), vertical
                      projects are beginning to appear in the form of Apps, which, in many cases, support the desktop intranet
                      (and are also responsive) for the execution of tasks and activities. This is the case for companies like
                      <strong> Fastweb</strong> and <strong>Aboca</strong>, as well as some other examples we have observed.
                    </p>
                    <figure className="champions__img">
                      <Img fluid={data.case_aboca.childImageSharp.fluid} alt="Aboca"/> 
                      <figcaption>Aboca Intranet</figcaption>
                    </figure>

                    <p>
                      <strong>Push customization. </strong> 
                      Many intranet projects are beginning to use sophisticated internal environment
                      certain customization features: e.g. favourite links, widgets, filter options are now common place in
                      many projects. These are some of the case examples: <strong>Rai, Angelini, Ferrero, SUPSI</strong> to name a few.

                    </p>
                    <figure className="champions__img">
                      <Img fluid={data.tendenze_angelini.childImageSharp.fluid} alt="Angelini"/> 
                      <figcaption>A customization feature from the Angelini intranet</figcaption>
                    </figure>


                    <p>
                      <strong>Targeted Content. </strong> 
                      The intranet is becoming ever more sophisticated and capable of reaching a
                      diversified audience of employees based on their department, sector or nation. The <strong>IMA, Ferrero</strong>, and
                      <strong> Bologna Airport</strong> projects express this trend well with their push profiling providing relevant content and
                      eliminating “noise”.
                    </p>
                    <figure className="champions__img">
                      <Img fluid={data.tendenze_adb.childImageSharp.fluid} alt="Aereoporto di Bologna"/> 
                      <figcaption>Targeted Content from Bologna Airport</figcaption>
                    </figure>

                    <p>
                      <strong>Online and offline link up. </strong> 
                      In many projects the barrier between offline and online is gradually getting
                      thinner: many projects are developed online and end up “live” or vice versa, or simply display greater
                      cooperation in these two areas of internal communication. This strong tie between the physical world
                      and the digital world is, perhaps, the characterising trait of Italian projects compared to foreign projects,
                      and can be observed for the following example projects: <strong>Poste Italiane, Tim, Gruppo Sella, Iren.</strong>
                    </p>
                    <figure className="champions__img">
                      <Img fluid={data.tendenze_iren.childImageSharp.fluid} alt="IREN"/> 
                      <figcaption> Iren’s project values</figcaption>
                    </figure>


                    <p>
                      <strong>New editorial formats. </strong>  
                      Apart from news and notices, intranet platforms are starting to provide high
                      quality multimedia content, both audio and video, and sophisticated publishing initiatives, such as in
                      the case of <strong>Sky</strong> or <strong>Generali Italia</strong>.
                    </p>
                    <figure className="champions__img">
                      <Img fluid={data.tendenze_sky.childImageSharp.fluid} alt="SKY"/> 
                      <figcaption>“Challenge the expert”, one of the many formats available on the Sky intranet platform</figcaption>
                    </figure>

                    <p>
                      <strong>Widespread Social Networking. </strong> 
                      The social elements, linked to the evolution of the network in recent
                      years, are starting to become widely accepted with a certain naturalness even inside, judging by the
                      number of comments, likes and news feeds (already present for example in companies like <strong>Sky,
                      Fastweb, Poste</strong>, and <strong>Tim</strong>) to a point where true communities (e.g. <strong>Fater</strong> and <strong>Generali</strong>) have formed
                      where debates, and collaboration groups take place.
                    </p>
                    
                    <figure className="champions__img">
                      <Img fluid={data.tendenze_generali.childImageSharp.fluid} alt="Generali"/> 
                      <figcaption>The Generali “Social Wall”.</figcaption>
                    </figure>      

                    <p>
                      <strong>Towards the digital workplace. </strong> 
                      Companies are increasingly gearing themselves up to making the
                      intranet the gateway towards an integrated application ecosystem, capable of communicating with the
                      main internal systems so as to create a true digital workplace with a smoother and more effective user
                      experience for their employees. An important challenge was met by the following example projects:
                      <strong>Rai, Istat</strong> and <strong>SUPSI</strong>
                    </p>
                    <figure className="champions__img">
                      <Img fluid={data.tendenze_rai.childImageSharp.fluid} alt="RAI"/> 
                      <figcaption>Rai Place</figcaption>
                    </figure>   
                   

                  </div>

                  <div id="report" className="page-section">
                    <h1>To know more:<br/> report IIC 2019</h1>
                   

                    <div className="champions__internalCTA">
                      <a href="https://www.intranetitaliaday.it/scarica-report-iic/?edizione=2019" title="Scarica il report IIC 2019" target="_blank" rel="noopener noreferrer" className="btn-cta btn-style-1">
                      Buy the report
                      </a>
                      {/*
                      <button onClick={e => navigate(translatePage('/acquista-report-iic-2019/',locale))} className="btn-cta btn-style-1">
                        Buy the report
                      </button>
                      */}
                    </div> 
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Newsletter />
      </div>
    </Layout >
    )
  }}
 />
);

export default Report2019;
